// extracted by mini-css-extract-plugin
module.exports = {"root":"CommSubjectField_root__2jaxc","label":"CommSubjectField_label__9aF-W","variablesRoot":"CommSubjectField_variablesRoot__ensSQ"};